


(function(){

    const MARGIN_TOP = 20;
    const MARGIN_BOTTOM = 20;
    const MARGIN_LEFT = 15;
    const MARGIN_RIGHT = 15;

    const CIRCLE = 30;
    const SPACE_X = 40;
    const SPACE_Y = 50;

    const OFFSET_TEXT1 = -22;
    const OFFSET_TEXT2 = +30;

    function cx_fn(x)  {
        return MARGIN_LEFT +(CIRCLE/2) + x * (SPACE_X+CIRCLE);
    }

    function cy_fn($y){
        return MARGIN_TOP + (CIRCLE/2) + $y * (SPACE_Y+CIRCLE);
    }

    const CANVAS_WIDTH  = cx_fn(4)-(CIRCLE/2+SPACE_X) + MARGIN_RIGHT;
    const CANVAS_HEIGHT = cy_fn(3)-(CIRCLE/2+SPACE_Y) + MARGIN_BOTTOM;


    const COLORS = [
        '#CECDCC', // Not detected
        '#fac940', // Very low
        '#f4d58a', // Low
        '#c3dcf0', // Medium
        '#85c5fa', // High
        '#1787e5', // Very high
    ];


    function rank_color(r){
        if(isNaN(r)) r=0;
        r = Math.min(Math.max(0,r),5);
        return COLORS[r];
    }

    //
    // SVG Namespace
    //
    const svgNS = "http://www.w3.org/2000/svg";


    /**
     * The function that creates a svg summary
     * @param report
     * @param height
     */
    ws.svg_summary_widget_big = function(report, report_shi = null, height = CANVAS_HEIGHT){

        const values = [
            [report.biodiversity_rank, report.functionality_rank, report.resistance_rank],
            [report.healthiness_rank,  report.biocontrol_rank,    report.hormoneprod_rank, report.stressadapt_rank],
            [report.nutrition_c_rank,  report.nutrition_n_rank,   report.nutrition_p_rank, report.nutrition_k_rank],
        ];

        if(report_shi !== null)
            values[0].prepend(report_shi.rank);

        let trans = window.trans;
        if(!trans){
            trans = x => "Missing JS trans ('" + x + "')";
        }

        const names = [
            [   trans('becrop_report.biosustainability_items.biodiversity'),
                trans('becrop_report.biosustainability_items.functionality'),
                trans('becrop_report.biosustainability_items.resistance')
            ],
            [
                trans('becrop_report.health_items_short.healthiness'),
                trans('becrop_report.health_items_short.biocontrol'),
                trans('becrop_report.health_items_short.hormone'),
                trans('becrop_report.health_items_short.stress')
            ],
            ['C','N','P','K',],
        ];


        //
        // Options
        //
        let scale = height / CANVAS_HEIGHT;
        let width = CANVAS_WIDTH*scale;


        //
        // Create the svg
        //
        const svg = document.createElementNS(svgNS, "svg");
        svg.setAttribute("width",  width);
        svg.setAttribute("height", height);
        svg.setAttribute("class", "svg_summary_widget_big");



        //
        // The group
        //
        const g = document.createElementNS(svgNS, "g");
        g.setAttribute("transform",  "scale(" + scale + ")");
        svg.appendChild(g);


        //
        // The circles
        //
        values.map((row,j) => {
            row.map((val, i) => {

                const cx = cx_fn(i);
                const cy = cy_fn(j);

                //
                // Circle
                //
                const circle = document.createElementNS(svgNS, "circle");
                circle.setAttribute("cx", cx);
                circle.setAttribute("cy", cy);
                circle.setAttribute("r",CIRCLE/2);
                circle.setAttribute("fill", rank_color(val));
                g.appendChild(circle);

                //
                // Name
                //
                const name = document.createElementNS(svgNS, "text");
                name.textContent = names[j][i];
                name.setAttribute("x",cx);
                name.setAttribute("y",cy + OFFSET_TEXT1);
                name.setAttribute("text-anchor","middle");
                name.setAttribute('class', 'name');
                g.appendChild(name);

                //
                // Value
                //
                const value = document.createElementNS(svgNS, "text");
                value.textContent = trans('becrop_report.rank_level.' + val );
                value.setAttribute("x",cx);
                value.setAttribute("y",cy + OFFSET_TEXT2);
                value.setAttribute("text-anchor","middle");
                value.setAttribute('class', 'value');
                g.appendChild(value);

            })
        });

        return svg;

    };


})();


